import type { CloudAccountType } from '@labrav/react-components'
import { CloudType } from '../../../types/external'

export const getCloudAccountsForMappingManager = (
  cloudAccounts: CloudAccountType[],
  disabledClouds: CloudType[]
) => {
  return cloudAccounts.map(account => ({
    ...account,
    disabled: disabledClouds.includes(account.provider as CloudType),
  }))
}
